import { Injectable } from '@angular/core';
import { ConfigService } from '../core/services/config.service';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class SummaryGenrationParameterServiceService {
  addAPI =  "/api/adsumparam";
  updateAPI =  "/api/updtsumparam";
  getAPI =  "/api/gtsumparam";
  changeStatusAPI =  "/api/chngsumparamsts";
  SummaryParamDataExcelAPI= "/api/genrtsumparamxls";

  constructor(
    private http: HttpClient,
    private configService: ConfigService
  ) { }

  Add(detail: any) {
    return this.http.post(this.addAPI, detail);
  }

  Update(detail: any) {
    return this.http.post(this.updateAPI, detail);
  }
  
  GetData(detail: any){
    return this.http.post(this.getAPI, detail);
  }

  ChangeStatus(statusDetail: { IsActive: any; ID: any; }) {
    return this.http.post(this.changeStatusAPI, statusDetail);
  }

  GetSummaryParamDataToXLS(pagination: any) {
    const body = {};
    return this.http.post(this.SummaryParamDataExcelAPI, pagination, body);
  }
}
